"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require("../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MediaController = function () {
  function MediaController(MediaService, FilterService, $scope) {
    "ngInject";

    (0, _classCallCheck3.default)(this, MediaController);
    this.mediaService = MediaService;
    this.filterService = FilterService;
    this.$scope = $scope;
    this.gridOptions = this.getGridOptions();
  }

  (0, _createClass3.default)(MediaController, [{
    key: "$onInit",
    value: function $onInit() {
      this.mediaReviewStatusOptions = {
        dataSource: [{ value: 0, text: "Unspecified" }, { value: 1, text: "Pending" }, { value: 2, text: "Approved" }, { value: 3, text: "Rejected" }],
        dataTextField: "text",
        dataValueField: "value"
      };
    }
  }, {
    key: "getGridOptions",
    value: function getGridOptions() {
      var _this = this;

      return {
        dataSource: this.mediaService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
        sortable: true,
        pageable: true,
        resizable: true,
        height: "90vh",
        noRecords: {
          template: "No match found. Change your filter criteria."
        },
        columns: [{ field: "creationDate", title: "Date", template: "<span>#= kendo.toString(new Date(creationDate), 'dd-MM-yyyy') #</span>", filterable: false, width: "6rem" }, { title: "Name", template: "<a class=\"cell\" href=\"#= '/users/' + userId #\">#= firstName + \" \" + lastName #</a>", filterable: false, sortable: false, width: "10rem" },
        // { field: "mediaStatus", title: "Media Status", filterable: false, sortable: false, width: "8rem" },
        { field: "mediaReviewStatus", title: "Review Status", filterable: false, sortable: true, width: "8rem", template: function template(dataItem) {
            return "" + _this._getMediaReviewStatus(dataItem.mediaReviewStatus);
          } }, { field: "duration", title: "Duration in seconds", filterable: false, sortable: false, width: "6rem" }, { title: "Watch Media", filterable: false, sortable: false, width: "6rem", template: "<a class=\"cell\" target=\"_blank\" href=\"#= '//jugglestreet.wistia.com/medias/' + externalHashedId #\">Link to media</a>" }, { title: "Update Review Status", command: [{ name: "edit", text: "Update" }], width: "7rem" }],
        editable: {
          mode: "popup",
          window: { title: "Update Review Status" },
          template: kendo.template($("#popup-editor").html())
        }
      };
    }
  }, {
    key: "applyFilters",
    value: function applyFilters() {
      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
    }
  }, {
    key: "dataSourceFetchSuccessCallback",
    value: function dataSourceFetchSuccessCallback(e) {
      this.mediaMatchCount = this.gridOptions.dataSource.total();
      this.$scope.$apply();
    }
  }, {
    key: "dataSourceErrorSuccessCallback",
    value: function dataSourceErrorSuccessCallback(e) {
      var _this2 = this;

      if (e.xhr.status == 401) {
        this.authService.refreshToken().then(function (response) {
          _this2.applyFilters();
        }).catch(function (error) {
          _this2.authService.logout();
        });
      } else {
        this.authService.logout();
      }
    }
  }, {
    key: "_getMediaReviewStatus",
    value: function _getMediaReviewStatus(status) {

      switch (status) {
        case _constants2.default.mediaReviewStatuts.UNSPECIFIED:
          return "Unspecified";
        case _constants2.default.mediaReviewStatuts.PENDING:
          return "Pending";
        case _constants2.default.mediaReviewStatuts.APPROVED:
          return "Approved";
        case _constants2.default.mediaReviewStatuts.REJECTED:
          return "Rejected";
      }
    }
  }]);
  return MediaController;
}();

exports.default = MediaController;


/** WEBPACK FOOTER **
 ** ./client/app/containers/media/media.controller.js
 **/